// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1dW_C","title":"Info_title__1ifWq","selects":"Info_selects__1TEZO","requiredAsterisk":"Info_requiredAsterisk__21JRy"};